import {useContext} from "react";

import {includes, isEmpty} from "lodash";
import clsx from "clsx";
import {CartConfigContext} from "../../contexts/CartConfigContext";

export default function FreeShippingIndicator({priceCents, icon, className = "text-lg text-brand-bright"}) {
  const cartConfig = useContext(CartConfigContext) || {};

  window.KART = cartConfig;;

  if (hasFreeShipping({cartConfig, priceCents})) {
    return <div className={clsx(className)}>
      {icon && <span className={icon}/>}
      Free Shipping
    </div>
  }

  return null;
}

function hasFreeShipping({cartConfig, priceCents}) {
  if (isEmpty(cartConfig)) {
    console.warn("cart config is missing");
    return false;
  }

  if (!priceCents)
    return false;

  const {shippingMethods = [], freeShippingQualifyingPrice} = cartConfig;

  if (isNaN(freeShippingQualifyingPrice))
    return false;

  return +priceCents >= +freeShippingQualifyingPrice;
}
